<template>
    <b-modal v-model="localShow" size="lg" centered hide-footer hide-header>
        <b-row align-h="around">
            <b-col align-self="end" cols="10"></b-col>
            <b-col align-self="end" cols="2">
                <img
                    @click="localShow = false"
                    class="close"
                    src="@/assets/images/mood-pulse/close.svg"
                />
            </b-col>
        </b-row>
        <b-container fluid>
            <b-row class="pt-2 pb-4" align-h="center">
                <p class="title">
                    {{ $t('moodPulse.pauseModal.title') }}
                </p>
            </b-row>
            <b-row class="pl-2 pr-1" align-h="center">
                <p class="text">
                    {{ $t('moodPulse.pauseModal.text1') }}
                    <span style="font-weight: bold">
                        {{ $t('moodPulse.pauseModal.link1') }}
                    </span>
                    {{ $t('moodPulse.pauseModal.text2') }}
                    <br />
                    <br />
                    {{ $t('moodPulse.pauseModal.text3') }}
                </p>
            </b-row>
            <b-row class="pb-2 pt-3" align-h="center">
                <b-button @click="updateStatus" class="mr-3" variant="primary">
                    {{ $t('moodPulse.pauseModal.okBtn') }}
                </b-button>
                <b-button @click="localShow = false" variant="outline-primary">
                    {{ $t('moodPulse.pauseModal.cancelBtn') }}
                </b-button>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
export default {
    name: 'PauseStatusModal',
    props: {
        show: {
            required: true,
            type: Boolean,
        },
        updateStatus: {
            required: true,
            type: Function,
        },
    },
    computed: {
        localShow: {
            get() {
                return this.show
            },
            set(localShow) {
                this.$emit('click', localShow)
            },
        },
    },
}
</script>

<style scoped>
.title {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;

    color: #022b4f;
}

.text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.002em;

    color: #3b3f4e;
}
</style>
